document.addEventListener('DOMContentLoaded', function () {
  (function () {
    const modal    = document.getElementById('hdiy-pickup-modal');
    const openBtn  = document.getElementById('hdiy-pickup-open');
    const closeBtn = document.getElementById('hdiy-pickup-close');
    if (!modal || !openBtn || !closeBtn) return;

    function openModal() {
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function closeModal() {
      modal.classList.remove('active');
      document.body.style.overflow = '';
      openBtn.focus();
    }

    openBtn.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) closeModal();
    });
  })();
});
